<template>
    <k-page>
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container size="lg" class="pb-20">
            <k-alert class="mt-6" v-if="!$root.$data.investorProfile.active">
                <template slot="text">{{ $t("accountNotActive") }}</template>
                <template slot="description">
                    {{ $t("accountNotActiveDesc") }}
                </template>
            </k-alert>

            <k-tabs class="mt-10"
                    v-if="$root.$data.investorProfile.active"
                    tab-class="k-tab-profile"
                    active-tab-class="k-tab-profile-active">
                <k-tab title="Deposit funds" class="mt-10 bo">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <add-funds-faq/>
                        <credentials-of-beneficiary/>
                    </div>
                </k-tab>
                <k-tab title="Withdraw funds" class="mt-10">
                    <div class="max-w-3xl mx-auto" v-if="!bankAccountsAvailable">
                        <k-panel>
                            <h1 class="text-3xl font-bold mb-8">Enter bank details</h1>
                            <bank-account-details-form
                                :validation="validation"
                                :accountHolderName="investorName"
                                @submit="onSubmitBankDetails"
                            />
                        </k-panel>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <withdraw-funds-form
                            ref="form"
                            :accounts="$root.$data.investorProfile.accounts"
                            :bank-accounts="bankAccounts"
                            :validation="validation"
                            :default-amount="withdrawAmount"
                            @withdraw="submitWithdraw"
                            v-if="bankAccountsAvailable"
                        />
                    </div>
                </k-tab>
                <k-tab :title="$t('currencyExchangeTab')" class="mt-10" v-if="currencyExchangeEnabled">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <currency-exchange-form
                            ref="form"
                            :accounts="$root.$data.investorProfile.accounts"
                            :bank-accounts="bankAccounts"
                            :validation="validation"
                            :default-amount="withdrawAmount"
                            @submitCurrencyExchangeRequest="submitCurrencyExchangeRequest"
                            v-if="bankAccountsAvailable"
                        />
                    </div>
                </k-tab>
            </k-tabs>
        </k-container>
    </k-page>
</template>

<script>
import ProfileHeader from '@investor/components/profile/ProfileHeader';
import KTabs from "@common/components/tabs/KTabs";
import KTab from "@common/components/tabs/KTab";
import AddFundsFaq from "@product-common/components/wallet/AddFundsFaq";
import CredentialsOfBeneficiary from "@product-common/components/wallet/CredentialsOfBeneficiary";
import WithdrawFundsForm from "@product-common/components/wallet/WithdrawFundsForm";
import CurrencyExchangeForm from "@product-common/components/wallet/CurrencyExchangeForm";
import BankAccountDetailsForm from '@product-common/components/investor/BankAccountDetailsForm';

export default {
    components: {
        KTab,
        KTabs,
        ProfileHeader,
        AddFundsFaq,
        CredentialsOfBeneficiary,
        WithdrawFundsForm,
        BankAccountDetailsForm,
        CurrencyExchangeForm
    },
    data() {
        return {
            loading: false,
            bankAccounts: [],
            currencyExchangeEnabled: false,
            investorName: this.$root.$data.investorProfile.firstName + ' ' + this.$root.$data.investorProfile.lastName,
            validation: {
                fieldErrors: {}
            },
            withdrawAmount: 10
        }
    },
    async mounted() {
        await this.refresh();
    },
    computed: {
      bankAccountsAvailable() {
          return this.bankAccounts.length > 0;
      }
    },
    methods: {
        async refresh() {
            try {
                const {data} = await this.$http.get('/api/investor/bank-accounts', {});
                this.bankAccounts = data.bankAccounts;
                const settings = await this.$http.get('/api/investor/public/web-settings', {});
                this.currencyExchangeEnabled = settings.data.currencyExchangeEnabled
            } catch (e) {
                console.error(e)
            }
        },
        async submitWithdraw(form) {
            this.validation = {
                fieldErrors: {}
            };
            try {
                await this.$post('request-withdrawal', form);
                await this.$fetchInvestorProfile()
                this.$refs.form.reset();
                this.$trackGAEvent('payout', 'payout');
                this.$trackGADataLayerEvent('fe-payout', this.$root.$data.investorProfile.number)
                this.$message.success("Your withdrawal request has been received and submitted successfully! \nWe will process it within 1-2 days and provide you with an update accordingly.");


            } catch (error) {
                console.error(error)
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data;
                    const fieldErrors = error.response.data.fieldErrors;
                     if (fieldErrors && fieldErrors.amount === "INVALID_VALUE") {
                        this.$message.error("Insufficient balance! \nPlease ensure you have sufficient funds before requesting a withdrawal.");
                     }

                }
            }
        },
        async submitCurrencyExchangeRequest(form) {
            this.validation = {
                fieldErrors: {}
            };
            try {
                await this.$post('request-currency-exchange', form);
                await this.$fetchInvestorProfile()
                this.$refs.form.reset();
                this.$message.success("Thank you for your request. Our team will need 2 days to process it and will get back to you soon.")
            } catch (error) {
                console.error(error)
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data;
                }
            }
        },
        fieldError(field) {
            return this.validation.fieldErrors[field];
        },
        async onSubmitBankDetails(form) {
            this.validation = {
                fieldErrors: {}
            };
            try {
                await this.$post('registration/bank-account-details', form);
                await this.refresh();
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data;
                    this.$scrollToErrorField();
                }
            }
        },

    }
}
</script>


